var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"margin-top-10 text-warning d-flex align-item-center"},[_c('app-icon',{staticClass:"mr-2",attrs:{"name":"alert-circle"}}),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"2px"}},[_vm._v(" "+_vm._s(_vm.$t('clicking_remove_file_will_remove_the_image_indefinitely'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }